module.exports = __webpack_public_path__ + "TB_Eating_Melody_A.wav.81f2b5dc.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_Melody_A.wav.mp3
// module id = 492
// module chunks = 0